export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

/* 手机号码 */
export const isPhone = (str: string) => {
  const reg = /^1[0-9]{10}$/
  return reg.test(str)
}

/* 数字字符串 */
export const isValidateNumberStr = (str:string) => {
  const reg = /^[0-9]*$/
  return reg.test(str)
}

export const validatePhone = (rule: any, value: string, callback: Function) => {
  if (!isPhone(value)) {
    callback(new Error('手机号码格式错误'))
  } else {
    callback()
  }
}
/* 检查验证码 */
export const validateCode = (rule:any, value:string, callback:Function) => {
  if (!value) {
    return callback(new Error('验证码不能为空'))
  }
  if (value.length !== 4 || !isValidateNumberStr(value)) {
    return callback(new Error('验证码不合法'))
  }
  callback()
}
export const validateRequirePhone = (rule: any, value: string, callback: Function) => {
  if (!value) {
    callback(new Error('请输入'))
  } else if (!isPhone(value)) {
    callback(new Error('手机号码格式错误'))
  } else {
    callback()
  }
}
/** 正整数 */
export const isPositiveInteger = (str: any) => {
  const reg = /^\+?[1-9][0-9]*$/
  return reg.test(str)
}
export const validatePositiveInteger = (rule: any, value: string, callback: Function) => {
  if (!isPositiveInteger(value)) {
    callback(new Error('请输入正整数'))
  } else {
    callback()
  }
}
export default {
  validatePhone,
  validateRequirePhone,
  validateCode,
  isPositiveInteger,
  validatePositiveInteger
}
